import React from 'react';
import { Link } from 'react-router-dom';
import { stories } from '../data/mockData';
import { PageHero } from '../components/PageHero';
import { RangeCard } from '../components/RangeCard';
import { CardCarousel } from '../components/CardCarousel';

/** Index of the SOUTH AFRICAN place & mood ranges — Choose Your Story. */
export function Stories() {
  return <div className="w-full bg-paper" data-id="element-915" data-mp="3o2mzczs9xzqv">
      <PageHero eyebrow="Choose Your Story" title="Pick the one that sounds like your morning." intro="Our South African layer — places and moods from this country, made with artists who live here. Four stories, each with its own cups." tone="pennant" data-id="element-916" data-mp="3a4f18oji4se4" />

      <section className="mx-auto max-w-[1400px] px-6 py-20 md:py-24" data-id="element-917" data-mp="355bwz6bciq77">
        <CardCarousel data-id="element-918" data-mp="357ooaa2zucwx">
          {stories.map((s, i) => <RangeCard key={s.id} range={s} index={i} data-id="element-919" data-mp="ygp7pg0uiwu6" data-mpi={i} />)}
        </CardCarousel>

        <div className="mt-20 flex flex-col items-start gap-6 rounded-4xl border border-oat/70 bg-paper-warm p-10 md:flex-row md:items-center md:justify-between md:p-12" data-id="element-920" data-mp="13dfk9tdfzaau">
          <div data-id="element-921" data-mp="7lz4118bhgns">
            <p className="type-eyebrow mb-3 text-[10px] text-coffee/50" data-id="element-922" data-mp="7kfnramnv5m0">
              A different path
            </p>
            <h2 className="type-display text-3xl text-coffee md:text-4xl" data-id="element-923" data-mp="m9txwky29r2g">
              Shop by Collection
            </h2>
            <p className="type-body mt-3 max-w-lg text-sm text-ink/65" data-id="element-924" data-mp="hdd8zoj1f8ob">
              The official artist and heritage ranges — William Morris, the Van
              Gogh Museum, Emma Shipley and Kew Gardens.
            </p>
          </div>
          <Link to="/collections" className="type-cta shrink-0 rounded-full bg-coffee px-8 py-4 text-[11px] text-paper transition-colors hover:bg-pennant" data-id="element-925" data-mp="2mw1bnft7miz">
            View the collections
          </Link>
        </div>
      </section>
    </div>;
}